import { Infobulle } from './Infobulle';

/**
 * L'entité en pastille, à sa couleur.
 *
 * Même dessin que la pastille du bandeau (point plein, liseré et texte à
 * la couleur de l'entité) : RG-28 demande que l'entité soit
 * identifiable en permanence, et deux dessins différents pour la même
 * notion feraient perdre le réflexe.
 *
 * Le fond reste blanc : une pastille pleine imposerait de calculer la
 * lisibilité du texte pour chaque couleur saisie, et une entité peut en
 * choisir une claire.
 */
/**
 * Le POINT seul, sans le code : la source d'une ligne quand la colonne
 * n'a pas la place d'un tag (fiche d'un salarié, 2026-10-03). Le code et
 * la raison sociale survivent dans l'infobulle.
 */
export function PointEntite({ code, couleur, titre }: { code: string; couleur: string; titre?: string }) {
  return (
    <Infobulle texte={titre ?? code} className="inline-flex shrink-0 align-middle">
      <span
        className="inline-block h-2.5 w-2.5 shrink-0 rounded-full"
        style={{ backgroundColor: couleur }}
        role="img"
        aria-label={code}
      />
    </Infobulle>
  );
}

export function TagEntite({
  code,
  couleur,
  titre,
}: {
  code: string;
  couleur: string;
  titre?: string;
}) {
  return (
    <Infobulle
      texte={titre}
      className="inline-flex items-center gap-1.5 rounded-full border bg-white px-2 py-0.5 text-xs font-medium"
      style={{ borderColor: couleur, color: couleur }}
    >
      <span className="h-2 w-2 shrink-0 rounded-full" style={{ backgroundColor: couleur }} aria-hidden />
      {code}
    </Infobulle>
  );
}
